export type BudgetAbnormalInfo = {
  isAbnormal: boolean;
  abnormalReason: string;
};

export const getBudgetAbnormalInfoFromPeak = (peakAbsDiffRate: number | null | undefined): BudgetAbnormalInfo => {
  const peak = peakAbsDiffRate ?? 0;
  if (peak <= 0.25) {
    return { isAbnormal: false, abnormalReason: '' };
  }

  return {
    isAbnormal: true,
    abnormalReason: `SPU预算偏差峰值 ${(peak * 100).toFixed(0)}%`,
  };
};
